module.exports = __webpack_public_path__ + "static/media/instagram-colored.8290266a.png";